import consumer from "./consumer";

export function subscribeDriverAlerts(deviceId = "all") {
  return consumer.subscriptions.create(
    { channel: "DriverAlertsChannel", device_id: deviceId },
    {
      connected() {
        console.log("[WS] driver_alerts connected:", deviceId);
      },
      received(data) {
        insertAlertRow(data);
      },
    }
  );
}

function insertAlertRow(data) {
  const tbody = document.querySelector("#event-list-table tbody");
  if (!tbody) return;

  // Check if this alert_id already exists in the table
  if (
    document.querySelector(
      `#event-list-table tbody tr[data-alert-id="${data.alert_id}"]`
    )
  ) {
    return; // already present, skip inserting duplicate
  }

  const when = data.event_time ? new Date(data.event_time) : new Date();
  const row = `
    <tr data-alert-id="${data.alert_id}">
      <td>${data.alert_id || ""}</td>
      <td>${when.toLocaleString()}</td>
      <td>${data.device_name || data.device_id || ""}</td>
      <td>${data.driver_name || ""}</td>
      <td>${data.alert_type || ""}</td>
      <td>${data.location?.address || ""}</td>
      <td>${
        data.image_url
          ? `<img src="${data.image_url}" style="max-height:60px">`
          : ""
      }</td>
    </tr>`;
  tbody.insertAdjacentHTML("afterbegin", row);
}

